module.exports = new __parcel__URL__("throw.d5edeef4.wav").toString();